import React from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { StyledTextDiv } from 'src/pages/reportUsage/utils/reportUsage.styled';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import { useTranslation } from 'react-i18next';
import { FONT_FAMILY_DEMI, SEMANTIC_TEXT_SMALL_PX, SMALL_TEXT_PX, TITLE_FONT_COLOR } from '../../../../../../styles/fonts/MCFontConstants';


const useStyles = makeStyles(() => ({
    paper: {
        padding: '14px',
    },
}));

const RowHeaderTemplateMobile = ({ gridData, headerCheckboxClickHandler }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <React.Fragment>
            <Box
                className={classes.paper}
                my={1}
                bgcolor={'#ffffff'}
                boxShadow={2}
                style={{ height: '52px', padding: '16px' }}
            >
                <Grid container alignItems={'flex-start'}>
                    <Grid item xs={10} style={{ display: 'flex' }}>
                        <Checkbox
                            id="headerCheckbox"
                            checked={
                                gridData?.filter(
                                    (x) => !x.isExcludedItem && !x.accountOwned
                                )?.length > 0 &&
                                gridData
                                    .filter(
                                        (x) =>
                                            !x.isExcludedItem && !x.accountOwned
                                    )
                                    .every((y) => y.isSelected)
                            }
                            label={t('consignmentBilling.replen.replenListView.replenListViewMobile.selectAllLabel')}
                            labelStyleObj={{
                                fontFamily: FONT_FAMILY_DEMI,
                                textAlign: 'left',
                                fontSize: SEMANTIC_TEXT_SMALL_PX,
                                letterSpacing: '-0.12px',
                                color: TITLE_FONT_COLOR,
                                opacity: 1,
                                paddingLeft: SMALL_TEXT_PX,
                            }}
                            onCheckboxSelectionChange={
                                headerCheckboxClickHandler
                            }
                        />
                        {/* <StyledTextDiv
                            color="#1010EB"
                            style={{ paddingLeft: '14px' }}
                        >
                            Select All
                        </StyledTextDiv> */}
                    </Grid>
                    <Grid item xs={2} lg={1} md={1}>
                        <StyledTextDiv
                            style={{
                                float: 'right',
                                paddingRight: '4px',
                            }}
                        >
                            {t('consignmentBilling.replen.replenListView.replenListViewMobile.qty')}
                        </StyledTextDiv>
                    </Grid>
                </Grid>
            </Box>
        </React.Fragment>
    );
};

export default RowHeaderTemplateMobile;
